import backArrow from "assets/images/back-arrow.svg";
import classNames from "classnames";
import {common as strings} from "strings";

import Button, {ButtonLinkProps} from "components/Button";

import styles from "./MobileNavigationHeader.module.css";

export default function MobileNavigationHeader(props: {
  backTo?: string;
  backLabel?: string;
  rightLink?: {label: string} & ButtonLinkProps;
  leftLink?: {label: string} & ButtonLinkProps;
  alwaysShown?: boolean;
  onBack?: () => void;
}) {
  const {label, ...rightLink} = props.rightLink ?? {};
  const {label: leftLinkLabel, ...leftLink} = props.leftLink ?? {};
  return (
    <header
      className={classNames(
        props.alwaysShown ? styles.alwaysShown : styles.header,
        props.rightLink ? styles.flexEnd : null,
        props.leftLink ? styles.flexBetween : null,
      )}
    >
      {props.backTo !== undefined ? (
        <Button
          variant="minimal"
          iconLeft={() => <img src={backArrow} alt="" />}
          className={styles.back}
          labelClassName={styles.backLabel}
          to={props.backTo}
        >
          {props.backLabel ?? strings.back}
        </Button>
      ) : null}
      {leftLinkLabel && leftLink ? (
        <div className={styles.fitContent}>
          <Button variant="minimal" {...leftLink}>
            {leftLinkLabel}
          </Button>
        </div>
      ) : null}
      {label && rightLink ? (
        <div className={styles.fitContent}>
          <Button variant="minimal" {...rightLink}>
            {label}
          </Button>
        </div>
      ) : null}
      {props.onBack !== undefined ? (
        <Button
          variant="minimal"
          iconLeft={() => <img src={backArrow} alt="" />}
          className={styles.back}
          labelClassName={styles.backLabel}
          onClick={props.onBack}
        >
          {props.backLabel ?? strings.back}
        </Button>
      ) : null}
    </header>
  );
}
